export const fileDownload = (url, afterDownload) => {
    const link = document.createElement('a');
    link.href = url;
    link.style.display = 'none';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    if (typeof afterDownload === 'function') {
        afterDownload(false);
    }
};
